import React from 'react';
import { Card, Typography, Row, Col, Tag } from 'antd';
import { RobotOutlined } from '@ant-design/icons';

const { Title } = Typography;

const botCategories = [
  { name: 'Finanzas', count: 8, color: '#E8192C', bots: ['Bot Consolidador', 'Bot Flujo Efectivo', 'Bot KPI Reporter', 'Bot Nómina'] },
  { name: 'Logística', count: 7, color: '#197278', bots: ['Bot Comprador', 'Bot Temporadas', 'Bot Inventario'] },
  { name: 'Energía', count: 6, color: '#e17055', bots: ['Bot Monarca', 'Bot Combustible', 'Bot Estaciones'] },
  { name: 'Retail', count: 10, color: '#6c5ce7', bots: ['Bot Ventas', 'Bot Precios', 'Bot Catálogo'] },
  { name: 'Agro', count: 5, color: '#00b894', bots: ['Bot Nogalera', 'Bot Producción'] },
  { name: 'RRHH', count: 10, color: '#fdcb6e', bots: ['Bot Asistencia', 'Bot Vacaciones', 'Bot Onboarding', 'Bot Rotación'] },
];

const Bots = () => {
  return (
    <div>
      <Title level={3}>Panel de Bots IA</Title>
      <Row gutter={[16, 16]}>
        {botCategories.map((cat) => (
          <Col xs={24} sm={12} lg={8} key={cat.name}>
            <Card
              title={
                <span>
                  <RobotOutlined style={{ marginRight: 8, color: cat.color }} />
                  {cat.name}
                </span>
              }
              extra={<Tag color={cat.color}>{cat.count} bots</Tag>}
              bordered={false}
              style={{ borderRadius: 8 }}
            >
              {cat.bots.map((bot) => (
                <div key={bot} style={{ padding: '4px 0', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{bot}</span>
                  <Tag color="green" style={{ margin: 0 }}>Activo</Tag>
                </div>
              ))}
              <div style={{ color: '#999', fontSize: 12, marginTop: 8 }}>
                Monitoreo en tiempo real — Fase 3
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Bots;
